import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {type FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DialogPanel from '@/components/common/DialogPanel';
import InputNumber from '@/components/common/forms/InputNumber';
import Label from '@/components/common/Label';

//TYPES
type Props = {
  onClose: () => void;
  onCutChange: (weight?: number) => void;
};

const CuttingConfirmationDialog: FC<Props> = ({onClose, onCutChange}) => {
  const {t} = useTranslation();

  const [weight, setWeight] = useState<number>();

  const handleWeight = (realWeight: number) => setWeight(realWeight);
  const handleCut = () => {
    onCutChange(weight);
    onClose();
    setWeight(undefined);
  };

  return (
    <DialogPanel isOpen={true} label={t('cuttingConfirmation.notUndoTitle')} onClose={onClose}>
      <Stack direction="column" sx={{maxWidth: '350px', p: 1}}>
        <Typography gutterBottom>{t('cuttingConfirmation.notUndo')}</Typography>
        <Typography gutterBottom>{t('cuttingConfirmation.addRealWeight')}</Typography>
        <Typography sx={{my: 2}}>{t('cuttingConfirmation.sure')}</Typography>
        <Label value={t('cuttingConfirmation.realWeight')} required={false}>
          <InputNumber value={weight} onChange={handleWeight} />
        </Label>

        <Stack direction="row" sx={{justifyContent: 'space-between', mt: 4}}>
          <Button variant="contained" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button onClick={handleCut}>{t('cuttingConfirmation.markCut')}</Button>
        </Stack>
      </Stack>
    </DialogPanel>
  );
};
export default CuttingConfirmationDialog;
